var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyicon = function SvgCopyicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 0.25H4.1875C4.03832 0.25 3.89524 0.309263 3.78975 0.414753C3.68426 0.520242 3.625 0.663316 3.625 0.8125V3.625H0.8125C0.663316 3.625 0.520242 3.68426 0.414753 3.78975C0.309263 3.89524 0.25 4.03832 0.25 4.1875V13.1875C0.25 13.3367 0.309263 13.4798 0.414753 13.5852C0.520242 13.6907 0.663316 13.75 0.8125 13.75H9.8125C9.96168 13.75 10.1048 13.6907 10.2102 13.5852C10.3157 13.4798 10.375 13.3367 10.375 13.1875V10.375H13.1875C13.3367 10.375 13.4798 10.3157 13.5852 10.2102C13.6907 10.1048 13.75 9.96168 13.75 9.8125V0.8125C13.75 0.663316 13.6907 0.520242 13.5852 0.414753C13.4798 0.309263 13.3367 0.25 13.1875 0.25ZM9.25 12.625H1.375V4.75H9.25V12.625ZM12.625 9.25H10.375V4.1875C10.375 4.03832 10.3157 3.89524 10.2102 3.78975C10.1048 3.68426 9.96168 3.625 9.8125 3.625H4.75V1.375H12.625V9.25Z",
    fill: "#5F5F75"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copyicon.acadbf30.svg";
export { ForwardRef as ReactComponent };